// @ts-nocheck
import React, { Component } from 'react'
import { Spinner } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'

class LoadingScreen extends Component {
  render() {
    return (
      <div style={styles.container}>
        <Spinner size="large" />
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    paddingTop: 100,
    color: colors.darkgrey
  }
}

export default LoadingScreen
